import type { AppState } from 'src/types/appState';

export const payAndPostPageSelector = (state: AppState) => ({
  isPageReady: Boolean(state.tealium.userId),
});
